var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Collapse from 'bootstrap/js/dist/collapse';
export class SingleShow extends Component {
    constructor(isDebugEnabled = false) {
        super('SingleShow', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#btn-show-dates').on('click', (event, button) => {
                event.preventDefault();
                const bs_collapse = new BS_Collapse($('#collapse-3').get(0), { toggle: false });
                bs_collapse.show();
                $.scrollTo($('#collapse-3').position().y - 49 - parseInt($('body').css('--header-height')), 500);
            });
            if ($('body').hasClass('page-template-singles') && localStorage.getItem('previous-page-type') == 'agenda-dynamic') {
                $('.lnk-back-to-list').attr('href', $('.submenu a:last-child').attr('href'));
            }
            this.success();
        });
    }
}
